<app-titled-page heading="Órdenes">
  <router-outlet></router-outlet>
</app-titled-page>
